/* global window */
/* eslint-disable */

/**
 * Loads intercom chat passing in email so user can be identified
 */
export function loadIntercom(email) {

  window.intercomSettings = {
    app_id: 'q9vg2d46',
    email
  };

  !function () {
    var t = window,
      e = t.Intercom;
    if ("function" == typeof e) e("reattach_activator"), e("update", window.intercomSettings);
    else {
      var n = document, a = function () { a.c(arguments) };
      function c() {
        var t = n.createElement("script");
        t.type = "text/javascript",
          t.async = !0,
          t.src = "https://widget.intercom.io/widget/q9vg2d46";
        var e = n.getElementsByTagName("script")[0];
        e.parentNode.insertBefore(t, e)
      } a.q = [],
        a.c = function (t) {
          a.q.push(t)
        },
        t.Intercom = a,
        c();
        // t.attachEvent ?
        //   t.attachEvent("onload", c)
        //   : t.addEventListener("load", c, !1)
    }
  }();
}



// WEBPACK FOOTER //
// ./src/services/intercomService.js